export default /* HTML */ ` <div id="content-wrapper">
  <div class="not-wrapper">
    <div class="top-wrapper">
      <div class="title">NOT FOUND</div>
    </div>
    <div class="bottom-wrapper">
      <div class="left-wrapper">
        <img src="${require("../../static/images/notfound.jpg")}" alt="" />
      </div>
      <div class="right-wrapper">
        <div class="number">404</div>
        <div class="desc">
          <div class="">Go back!</div>
          <div class="">This page is missing!</div>
        </div>
      </div>
    </div>
  </div>
</div>`;
